/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ModelCommonResponse, ModelTableProjRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Project<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description add tables to one project
   *
   * @tags api
   * @name TableAddCreate
   * @summary add tables to one project
   * @request POST:/project/table/add
   */
  tableAddCreate = (
    request: ModelTableProjRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/project/table/add`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description delete tables from one project
   *
   * @tags api
   * @name TableDelCreate
   * @summary delete tables from one project
   * @request POST:/project/table/del
   */
  tableDelCreate = (
    request: ModelTableProjRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/project/table/del`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
